/*
 * @Author: Dong
 * @Date: 2022-04-07 18:34:45
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-28 16:09:26
 */
import React, { useState, useEffect } from 'react';
import NodeItem from './components/NodeItem';
import styles from './index.less';
import { setHosts } from 'root/store/nodeConfig/actions';
import { useDispatch } from 'react-redux';
import { nodeConfigListApi, middlewareDeployModeApi } from 'root/services/manager';
import { setNodeData } from 'root/store/nodeConfig/actions';

const List = () => {
  const dispatch = useDispatch();

  const [dataSource, setDataSource] = useState<any>([]);
  const [deployModeList, setDeployModeList] = useState<any>([]);

  useEffect(() => {
    getList();
    getDeployModeList();
  }, []);

  // 获取节点列表
  const getList = () => {
    nodeConfigListApi().then((res) => {
      const { data } = res;
      setDataSource(data);
      dispatch(setNodeData(data));

      // 将每个中间件需要的ip截取
      const hosts: any = {};
      data.forEach((item: any) => {
        const { labelName, nodeInfo, shouldNum } = item;
        const nodeHostList = nodeInfo.map((item: any) => item.ip);
        hosts[labelName] = nodeHostList.slice(0, shouldNum);
      });
      dispatch(setHosts(hosts));
    });
  };

  // 获取部署方式列表
  const getDeployModeList = () => {
    middlewareDeployModeApi().then((res) => {
      const { data } = res;
      setDeployModeList(data);
    });
  };

  return (
    <div className={styles.container}>
      {dataSource?.map((item: any, index: number) => {
        const { labelName, from, nodeInfo, shouldNum, nowNum, extraInfo, alreadyExtraInfo } = item;
        const curDeployItem = deployModeList.filter((item: any) => item.labelName === labelName);

        return (
          <NodeItem
            name={labelName}
            fromData={from}
            nodeList={nodeInfo}
            count={nowNum}
            total={shouldNum}
            key={index}
            options={extraInfo}
            existingServicesFrom={alreadyExtraInfo.form}
            deployMode={curDeployItem[0]?.deployModes}
          />
        );
      })}
    </div>
  );
};

export default List;
